import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyContent, IDeglawyContentStore,
} from '../../mobx-store/storeInterfaces/deglawyContentInterface';

interface IProps extends WithSnackbarProps {
  deglawyContentStore: IDeglawyContentStore;
  history: any;
}

interface TableData {
  id: number;
  title: string;
  body: string;
  edit: string;
}

@inject('deglawyContentStore')
@observer
class DeglawyContents extends Component<IProps> {
  // addButton?: any;
  tableHeader: any = [];

  tableData: TableData[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Deglawy Content Management';

  constructor(props: IProps) {
    super(props);
  }

  //   handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
  //     this.props.branchStore.updateBranchStatus(value, index);
  //   }

  handleTableButtonCellClicked = (index: number, key: string) => {
    console.log(index, key);
    this.props.history.push(`/deglawy/contents/${this.props.deglawyContentStore.deglawyContentsList[index].getId()}/edit`);
    // this.setState({ [name]: event.target.checked });
  };

  // handelAdd = (): void => {
  //     this.props.history.push('/staticTexts/new');
  //     console.log('add');
  // }

  // getAddDeglawyContentButton = () => {
  //     return {
  //         title: 'Add',
  //         onAdd: this.handelAdd,
  //     };
  // }

  getDeglawyContentTableHeader = () => [
    {
      title: translate('deglawyContentsTitlesColumnTitle', {
      }),
    },
    {
      title: translate('deglawyContentsEditColumnTitle', {
      }),
    },
  ];

  getDeglawyContentTableData = (): TableData[] => {
    console.log(this.props.deglawyContentStore.deglawyContentsList);
    return this.props.deglawyContentStore.deglawyContentsList
      .map((deglawyContent: DeglawyContent) => {
        console.log(deglawyContent);
        const deglawyContentData = {
          id: deglawyContent.getId(),
          title: translate(`${deglawyContent.getTitle()}`, {
          }),
          body: deglawyContent.getBody(),
          edit: 'Edit',
        };
        return deglawyContentData;
      });
  };

  getDeglawyContentTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.tableHeader = this.getDeglawyContentTableHeader();
    this.tableData = this.getDeglawyContentTableData();
    this.tableCellTypes = this.getDeglawyContentTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no contents yet."
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loading={this.props.deglawyContentStore.loading}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.deglawyContentStore.getDeglawyContents(DefaultLanguage);
  }
}

export default DeglawyContents;
